import React from "react";
import { connect } from "react-redux";
import { applySpec } from "ramda";
import { getEditMediaDisableSave } from "common/selectors";
import {makeStyles} from "@material-ui/core/styles";
import { hideDrawer, saveMediaItem } from "edit-media/redux/editMediaActions";
import AppBar from "@material-ui/core/AppBar";
import Button from '@material-ui/core/Button';
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/ArrowBack";
import SaveIcon from "@material-ui/icons/Save";
import {green, grey} from "@material-ui/core/colors";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    backgroundColor: grey[200],
  },

  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  saveButton: {
    backgroundColor: green[500],
    color: theme.palette.primary.contrastText,
  },
}));

const EditMediaActionBar = ({ disableSave, onBack, onSave }) => {
  const classes = useStyles();

  return (
    <AppBar className={classes.appBar}>
      <Toolbar classes={{root: classes.toolbar}}>
        <Button
          color="default"
          startIcon={<CloseIcon />}
          onClick={onBack}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          classes={{root: classes.saveButton}}
          onClick={onSave}
          disabled={disableSave}
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = applySpec({
  disableSave: getEditMediaDisableSave,
});

const mapDispatchToProps = dispatch => ({
  onSave: mediaItem => dispatch(saveMediaItem(mediaItem)),
  onBack: () => dispatch(hideDrawer()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMediaActionBar);
